import React from 'react'
import Typed from 'react-typed'
import { supabase } from '../lib/supabase'
const { useState, useEffect } = React;

const Hero = () => {
    const [mydata, setMydata] = useState([])
    const [loading, setLoading] = useState(true)
    const [countdownDate, setCountdownDate] = useState(undefined)
    const [currentDate, setCurrentDate] = useState(new Date())

    useEffect(() => {
        loadNextEvent()
        // Mettre à jour currentDate chaque seconde
        const timer = setInterval(() => {
            setCurrentDate(new Date())
        }, 1000)
        return () => clearInterval(timer)
    }, [])

    const loadNextEvent = async () => {
        try {
            const today = new Date()
            const { data, error } = await supabase
                .from('events')
                .select('*')
                .eq('status', 'published')
                .gte('date_end', today.toISOString())
                .order('date_start', { ascending: true })
                .limit(1)

            if (error) throw error
            setMydata(data || [])
        } catch (error) {
            console.error('Erreur lors du chargement du prochain événement:', error)
            setMydata([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (mydata && mydata.length > 0) {
            const nextDate = new Date(mydata[0].date_start) > new Date()
                ? new Date(mydata[0].date_start).getTime()
                : new Date(mydata[0].date_end).getTime()
            setCountdownDate(nextDate)
        }
    }, [mydata])

    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        if (countdownDate) {
            const timer = setInterval(() => {
                const currentTime = new Date().getTime();
                const distanceToDate = countdownDate - currentTime;

                if (distanceToDate < 0) {
                    setState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                    return;
                }

                let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
                let hours = Math.floor(
                    (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
                );
                let minutes = Math.floor(
                    (distanceToDate % (1000 * 60 * 60)) / (1000 * 60),
                );
                let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

                const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

                let daysStr = `${days}`;
                let hoursStr = numbersToAddZeroTo.includes(hours) ? `0${hours}` : `${hours}`;
                let minutesStr = numbersToAddZeroTo.includes(minutes) ? `0${minutes}` : `${minutes}`;
                let secondsStr = numbersToAddZeroTo.includes(seconds) ? `0${seconds}` : `${seconds}`;

                setState({ days: daysStr, hours: hoursStr, minutes: minutesStr, seconds: secondsStr });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [countdownDate]);
    return (
        <div className='sm:bg-hero-background bg-hero-phone-background w-full max-h-[1000px] min-h-[90vh] bg-cover bg-center '>
            <div className="px-[4%] text-center w-full max-h-[1000px] min-h-[90vh] bg-black bg-opacity-50 text-white flex justify-between flex-col items-center">
                <div className='pt-[5vh] sm:pt-[8vh]'>
                    {loading ? (
                        <div className='flex justify-center items-center min-h-[300px]'>
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
                        </div>
                    ) : (
                        <>
                            <p className='text-xl mt-[5vh] sm:mt-[8vh] font-extralight sm:text-2xl lg:text-4xl'>{mydata[0] ? mydata[0].date_show : ''}</p>
                            <h1 className='uppercase text-2xl sm:text-3xl font-extrabold py-10 lg:text-5xl'>{mydata[0] ? mydata[0].title : ""}</h1>
                            {mydata[0] && new Date(mydata[0].date_start) > currentDate ? (
                                <h1 className='text-xl sm:text-xl font-bold lg:text-xl pb-4'>La fête commence dans :</h1>
                            ) : (
                                <>
                                    <h1 className='text-xl sm:text-xl font-bold lg:text-xl'>La fête a déjà commencé, ils vous attendent nombreux !</h1>
                                    <h1 className='text-xl sm:text-xl font-bold lg:text-xl pb-4'>Elle finit dans :</h1>
                                </>
                            )}
                            <div className='w-full flex font-bold justify-around items-center lg:w-[80%] lg:m-auto'>
                                <div className='w-20 border rounded flex flex-col lg:w-24'>
                                    <div className='text-4xl font-bold border-b py-2 lg:text-5xl'>{state.days || '0'}</div>
                                    <small className="w-full text-xs uppercase py-1 lg:text-sm">Jours</small>
                                </div>
                                <div className='w-20 border rounded flex flex-col lg:w-24'>
                                    <div className='text-4xl font-bold border-b py-2 lg:text-5xl'>{state.hours || '00'}</div>
                                    <small className="w-full text-xs uppercase py-1 lg:text-sm">Heures</small>
                                </div>
                                <div className='w-20 border rounded flex flex-col lg:w-24'>
                                    <div className='text-4xl font-bold border-b py-2 lg:text-5xl'>{state.minutes || '00'}</div>
                                    <small className="w-full text-xs uppercase py-1 lg:text-sm">Minutes</small>
                                </div>
                                <div className='w-20 border rounded flex flex-col lg:w-24'>
                                    <div className='text-4xl font-bold border-b py-2 lg:text-5xl'>{state.seconds || '00'}</div>
                                    <small className="w-full text-xs uppercase py-1 lg:text-sm">Secondes</small>
                                </div>
                            </div>

                            <h1 className='uppercase text-xl font-bold w-fit mx-auto mt-24 bg-black rounded-lg p-1 sm:text-2xl'>
                                Prêt à&nbsp;
                                <Typed className='text-green-400'
                                    strings={[
                                        'faire la fête ?',
                                        'jouer à la pétanque ?',
                                        "s'amuser ?"
                                    ]}
                                    typeSpeed={90}
                                    backSpeed={70}
                                    loop
                                />
                            </h1>
                        </>
                    )}
                </div>
                <h2 onClick={() => window.scrollTo({ top: window.pageYOffset + (window.innerHeight * 0.901), behavior: 'smooth' })} className='flex justify-center animate-bounce-slow items-center text-xl font-bold pb-6 mb-14 sm:mb-0 sm:pb-8 sm:text-2xl hover:cursor-pointer'><img className='px-4' src="/images/Angle-double-down.svg" alt="" /> Alors c'est par là<img className='px-4' src="/images/Angle-double-down.svg" alt="" /></h2>
            </div>

        </div >
    )
}

export default Hero